import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { AdminPermissions } from 'app/library/feature/enums/admin-permissions.enum';
import { MaxBrainExperience } from 'app/library/experience/models/experience.model';
import { ExperienceService } from 'app/library/experience/services/experience.service';
import { FeatureService } from 'app/library/feature/services/feature.service';
import { SidenavService } from 'app/library/grow/services/sidenav.service';
import { FeatureSwitchName } from 'app/projects/shared/src/lib/enums/feature-switch.enum';
import { UserState } from 'app/projects/user/src/lib/models/user.state';

@Component({
    selector: 'app-experience',
    templateUrl: './experience.component.html',
    styleUrls: ['./experience.component.scss'],
})
export class ExperienceComponent implements OnInit {
    experience: MaxBrainExperience;
    experienceId: string;
    isCourseCatalogFeatureEnabled: boolean = false;
    categories = [
        {
            name: 'Home experience banner',
            description: 'ENGAGE.EXPERIENCE.LABELS.HOME_EXPERIENCE_BANNER.DESCRIPTION',
            url: 'home',
            action: 'Edit',
            cls: 'home',
            image: null,
        },
        { name: 'Widgets', description: 'ENGAGE.EXPERIENCE.LABELS.WIDGETS.DESCRIPTION', widgets: 0, url: 'widgets', action: 'Manage', cls: 'widgets', image: null },
        { name: 'Members', description: 'ENGAGE.EXPERIENCE.LABELS.MEMBERS.DESCRIPTION', members: 0, url: 'users', action: 'Edit', cls: 'members', image: null },
    ];

    screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    @HostListener('window:resize')
    onResize() {
        this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }

    constructor(
        private _route: ActivatedRoute,
        private _store: Store,
        private _experienceService: ExperienceService,
        public sidenavService: SidenavService,
        private _featureService: FeatureService
    ) {
        this.isCourseCatalogFeatureEnabled = this._featureService.checkFeatureStatus(FeatureSwitchName.CourseCatalog);
    }

    private get _permissions(): string[] {
        return this._store.selectSnapshot(UserState.getMyInfo)?.permissions ?? [];
    }

    get hasUsersReadPermission(): boolean {
        return (
            this._permissions.includes(AdminPermissions.USERS_READ) || this._permissions.includes(AdminPermissions.TENANT_MANAGEMENT)
        );
    }

    get hasCoursesReadPermission(): boolean {
        return (
            this._permissions.includes(AdminPermissions.COURSES_READ) || this._permissions.includes(AdminPermissions.TENANT_MANAGEMENT)
        );
    }

    isCategoryDisabled(category: { url: string }): boolean {
        if (category.url === 'users') {
            return !this.hasUsersReadPermission;
        }

        if (category.url === 'catalog') {
            return !this.hasCoursesReadPermission;
        }

        return false;
    }

    ngOnInit(): void {
        this._route.paramMap.subscribe(async (params) => {
            this.experienceId = params.get('id');
            this.experience = this._experienceService.getExperienceById(this.experienceId);
            if (this.experience) {
                this.categories[1].widgets = this.experience.widgetCount;
                this.categories[2].members = this.experience.memberCount;
                if (this.experience.headerBanner && this.experience.headerBanner.image) {
                    this.categories[0].image = this.experience.headerBanner.image;
                }
            }
        });

        if (this.isCourseCatalogFeatureEnabled) {
            this.categories.push({
                name: 'Course catalog',
                description: 'ENGAGE.EXPERIENCE.LABELS.CATALOG.DESCRIPTION',
                url: 'catalog',
                action: 'Manage',
                cls: 'catalog',
                image: null,
            });
        }
    }

    goBack(): void {
        this._store.dispatch(new Navigate([`/admin/grow/experience`]));
    }
}
